module.exports = __webpack_public_path__ + "img/312.1935321b.png";